import { Link } from '@/lib/nav';
import { ArrowRight } from 'lucide-react';
import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { WaitlistForm } from '@/components/forms/WaitlistForm';
import { ROUTES } from '@/lib/routes';

const CAPABILITIES = [
  'Auditar la coherencia entre la planificación institucional y la norma vigente.',
  'Identificar áreas no cubiertas o con baja cobertura.',
  'Generar reportes con cita textual.',
  'Hacer trazable la decisión curricular.',
];

export function Directivos() {
  return (
    <>
      <section className="rule-bottom">
        <Container className="pt-16 pb-16 md:pt-24 md:pb-20">
          <Eyebrow className="mb-8">Para directivos</Eyebrow>
          <h1 className="max-w-5xl font-display text-5xl font-medium leading-[1.05] tracking-tight text-accent md:text-6xl lg:text-7xl">
            Coherencia curricular,
            <br />
            <span className="font-normal italic">auditable y citada.</span>
          </h1>
          <p className="mt-8 max-w-prose text-lg leading-relaxed text-ink-muted md:text-xl">
            Sin leer manualmente cinco documentos. Con cita textual a la fuente.
          </p>
        </Container>
      </section>

      <Section className="pt-0">
        <Container width="editorial">
          <ul className="flex flex-col">
            {CAPABILITIES.map((c) => (
              <li
                key={c}
                className="border-t border-line py-5 font-serif text-lg leading-snug text-ink first:border-t-0"
              >
                {c}
              </li>
            ))}
          </ul>
        </Container>
      </Section>

      <Section ariaLabelledby="institucional-title" className="bg-paper-tinted/40">
        <Container width="editorial">
          <Eyebrow>Para tu institución</Eyebrow>
          <h2 id="institucional-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Si tu institución quiere SICA antes que el rollout individual, podemos hablar.
          </h2>
          <p className="prose-editorial mt-6">
            Trabajamos con instituciones para acelerar la cobertura de su jurisdicción y diseñar
            integraciones específicas con sus procesos pedagógicos.
          </p>
          <Link
            to={`${ROUTES.contacto}?perfil=directivo`}
            className="focus-ring mt-6 inline-flex items-center gap-1.5 rounded-full border border-line_strong px-5 py-2.5 text-sm font-medium text-ink hover:border-ink hover:bg-ink hover:text-paper"
          >
            Iniciar conversación institucional
            <ArrowRight size={14} />
          </Link>
        </Container>
      </Section>

      <Section ariaLabelledby="waitlist-title" className="border-t border-line">
        <Container width="editorial">
          <Eyebrow>Lista de espera</Eyebrow>
          <h2 id="waitlist-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Acceso anticipado para directivos.
          </h2>
          <WaitlistForm audience="directivos" className="mt-8" />
        </Container>
      </Section>
    </>
  );
}
